import { Title } from '#app/components/page-title'
import { cn } from '#app/utils/misc'

const PEOPLE = [
	{
		name: 'Angie',
		role: 'Maid of Honor',
		imgSrc: '/img/angie.JPEG',
		alt: 'Angie, Maid of Honor',
		description: `She'll be taking all my drinks for me`,
		nickName: 'The fun crazy bestie',
	},
	{
		name: 'Anthony',
		role: 'Best Man',
		imgSrc: '/img/anthony.png',
		alt: 'Anthony, the Best Man',
		description: `he'll always have my back, even if that means kicking someone out :)`,
		nickName: 'The most loyal bestie',
	},
	{
		name: 'David',
		nickName: 'The Goofy Bestie',
		role: 'Officiant',
		imgSrc: '/img/david.png',
		alt: 'David, the Goofy Bestie',
		description: `he'll have all the Asian dad jokes ready`,
		className: 'sm:col-span-2 sm:justify-center',
	},
]

export default function BestiesPage() {
	return (
		<main className="container flex flex-col py-10 sm:py-6">
			<Title title="Besties" />

			<ul className="mx-auto mt-10 grid max-w-2xl grid-cols-1 gap-x-6 gap-y-20 sm:grid-cols-2 lg:max-w-4xl lg:gap-x-8">
				{PEOPLE.map(person => (
					<li key={person.name} className={cn('flex', person.className)}>
						<div className="flex flex-col gap-6">
							<img
								className="aspect-[4/5] w-52 flex-none rounded-2xl object-cover md:w-72"
								src={person.imgSrc}
								alt={person.alt}
								loading="lazy"
							/>
							<div className="flex-auto">
								<h3 className="text-2xl font-semibold leading-8 tracking-tight text-gray-900 md:text-4xl">
									{person.name}
									{!!person.role && (
										<span className="text-xl md:text-2xl">
											{' '}
											- {person.role}
										</span>
									)}
								</h3>
								<p className="text-lg leading-7 text-gray-600 md:text-2xl">
									{person.nickName}
								</p>
								<p className="mt-4 text-lg leading-7 text-gray-600 md:text-2xl">
									{person.description}
								</p>
							</div>
						</div>
					</li>
				))}
			</ul>
		</main>
	)
}
